<h1 mat-dialog-title>Onward referral</h1>

<div mat-dialog-content class="rnr">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

    <div class="rnr__alert" *ngIf="loadError">
        <mat-icon>error_outline</mat-icon>
        <div>{{ loadError }}</div>
    </div>

    <ng-container *ngIf="notice">
        <div class="rnr__author" data-test="notice">
            <mat-icon>forward_to_inbox</mat-icon>
            <div>
                <div class="rnr__author-name">{{ notice.onwardPracticeName }} referred {{ data.patientName || 'your patient' }} onward</div>
                <div class="hint">To {{ notice.onwardRecipientName }} · {{ notice.createdAt | date: 'd MMM y, HH:mm' }}</div>
            </div>
        </div>
        <p class="hint">They accepted your referral of this patient. Only their own records go with the onward referral;
            nothing from your practice is sent on.</p>
        <div class="rnr__status" *ngIf="notice.acknowledgedAt">
            <mat-icon>check_circle</mat-icon>
            <div>Acknowledged on {{ notice.acknowledgedAt | date: 'd MMM y' }}</div>
        </div>
        <div class="rnr__alert" *ngIf="actionError">
            <mat-icon>error_outline</mat-icon>
            <div>{{ actionError }}</div>
        </div>
    </ng-container>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="close()" [disabled]="isSaving">Close</button>
    <button mat-flat-button color="primary" *ngIf="notice && !notice.acknowledgedAt" (click)="acknowledge()" [disabled]="isSaving" data-test="acknowledge">
        {{ isSaving ? 'Saving…' : 'Acknowledge' }}
    </button>
</div>
